import { z } from "zod";
import { TApiCRUDBy, TCRUDBy, TCRUDByTDate } from "./common/CRUDBy";

export type IObjectBaseTDate = z.infer<typeof TObjectBase>;
export const TObjectBaseTDate = z.object({
  id: z.string(),
  archived: z.optional(z.boolean()),
  deleted: z.optional(z.boolean()),
  deletedBy: z.optional(TCRUDByTDate),
  createdBy: z.optional(TCRUDByTDate),
  updatedBy: z.optional(TCRUDByTDate),
});

/**
 * @deprecated use IObjectBaseTDate instead
 */
export type IObjectBase = z.infer<typeof TObjectBase>;
/**
 * @deprecated use TObjectBaseTDate instead
 */
export const TObjectBase = z.object({
  id: z.string(),
  archived: z.optional(z.boolean()),
  deleted: z.optional(z.boolean()),
  deletedBy: z.optional(TCRUDBy),
  createdBy: z.optional(TCRUDBy),
  updatedBy: z.optional(TCRUDBy),
});

export type IApiObjectBase = z.infer<typeof TApiObjectBase>;
export const TApiObjectBase = z.object({
  id: z.string(),
  archived: z.optional(z.boolean()),
  deleted: z.optional(z.boolean()),
  deletedBy: z.optional(TApiCRUDBy),
  createdBy: z.optional(TApiCRUDBy),
  updatedBy: z.optional(TApiCRUDBy),
});

/**
 * @deprecated use TObjectBase instead
 */
export const ObjectBase = {
  id: z.string(),
  archived: z.optional(z.boolean()),
  deleted: z.optional(z.boolean()),
  deletedBy: z.optional(TCRUDBy),
  createdBy: z.optional(TCRUDBy),
  updatedBy: z.optional(TCRUDBy),
};

export type IFile = z.infer<typeof TFile>;
export const TFile = z.object({
  type: z.string().optional(),
  name: z.string().optional(),
  size: z.number().nullish(),
  path: z.string().optional(),
  externalURL: z.string().optional(),
  globalFileID: z.string().nullish(),
});

export type IGeoPoint = z.infer<typeof TGeoPoint>;
export const TGeoPoint = z.object({
  latitude: z.number(),
  longitude: z.number(),
});

export type IRawPublicKey = z.infer<typeof TRawPublicKey>;
export const TRawPublicKey = z.object({
  content: z.string(), // Encrypted content
  iv: z.string(), // Initialization Vector
});

export type IApiClientID = z.infer<typeof TApiClientID>;
export const TApiClientID = z.union([
  z.literal("fazile"),
  z.literal("famac"),
  z.literal("fenistra"),
  z.literal("findable"),
  z.literal("probase"),
  z.literal("adaptic"),
  z.literal("airthings"),
  z.literal("landax"),
  z.literal("hybel"),
  z.literal("lifeatwork"),
  z.literal("energinet"),
  z.literal("soundsensing"),
]);
